module.exports = __webpack_public_path__ + "static/assets/8ec069e13e90bb47735837abc3e07cb7.png";